import React, { FunctionComponent } from 'react'
import { usePagamentoBoleto } from '../../../../../hooks/usePagamentoBoleto'
import { Grid } from '@material-ui/core'
import { BoxValor, Divider, StyledGrid, TextBoleto } from '../styles'
import { colors } from '../../../../../../../shared/styles/colors'
import {
  formatBankSlip,
  numberToCurrency,
} from '../../../../../../../shared/utils/formatters'

const DetalheBoleto: FunctionComponent = () => {
  const { boleto } = usePagamentoBoleto()

  const renderItemDetalheBoleto = (
    titulo: string,
    descricao: string,
    showDivider = true,
  ): React.ReactElement => {
    return (
      <>
        <Grid item xs={6}>
          <TextBoleto
            $fontSize={'14px'}
            $fontWeight={'400'}
            $color={colors.gray7}
          >
            {titulo}
          </TextBoleto>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            textAlign: 'right',
            wordBreak: 'break-all',
          }}
        >
          <TextBoleto
            $fontSize={'14px'}
            $fontWeight={'400'}
            $color={colors.gray7}
          >
            {descricao}
          </TextBoleto>
        </Grid>
        {showDivider && (
          <Grid item xs={12}>
            <Divider />
          </Grid>
        )}
      </>
    )
  }

  return (
    <>
      <StyledGrid>
        <BoxValor
          style={{
            textAlign: 'left',
            height: 'auto',
            marginTop: 4,
            paddingLeft: 24,
            paddingRight: 24,
          }}
        >
          <Grid
            container
            spacing={0}
            alignContent={'center'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Grid
              item
              xs={12}
              style={{
                marginTop: 8,
              }}
            >
              <TextBoleto
                $fontSize={'16px'}
                $fontWeight={'600'}
                $color={colors.gray1}
              >
                Detalhes do boleto
              </TextBoleto>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {renderItemDetalheBoleto('Favorecido', boleto?.favorecido)}
            {renderItemDetalheBoleto('Banco', boleto?.banco?.nome)}
            {renderItemDetalheBoleto(
              'Valor',
              numberToCurrency(boleto?.valor_original ?? boleto?.valor),
            )}
            {renderItemDetalheBoleto(
              'Desconto',
              numberToCurrency(boleto?.valor_desconto ?? 0),
            )}
            {renderItemDetalheBoleto(
              'Multa',
              numberToCurrency(boleto?.valor_multa ?? 0),
            )}
            {renderItemDetalheBoleto(
              'Juros',
              numberToCurrency(boleto?.valor_juros ?? 0),
            )}
            {renderItemDetalheBoleto(
              'Código de barras',
              formatBankSlip(boleto?.codigo_barras),
              false,
            )}
          </Grid>
        </BoxValor>
      </StyledGrid>
    </>
  )
}

export default DetalheBoleto
